import JoinCodeResultListing from './JoinCodeResultListing';

export default JoinCodeResultListing;
